

import {
    t
} from "@lingui/macro"
import { MicrojobberWrapper } from "models/microjobber"
import { GridColDef } from "@mui/x-data-grid"


const defaultColumnDefinition: GridColDef = {
    field: "",
    headerName: "",
    headerAlign: "left",
    align: "left",
}
const getMicrojobTableColumns = (): GridColDef[] => {
    return [
        // {
        //     ...defaultColumnDefinition,
        //     field: "userImage",
        //     width: 100,
        //     renderCell: () => {
        //         return (<Avatar sx={{fontSize: "0.7em"}}>No logo</Avatar>)
        //     },
        //     sortable: false,
        // },
        {
            ...defaultColumnDefinition,
            field: "fullName",
            headerName: t({
                id: "mtc-user",
                message: "Utente",
            }),
            flex: 4,
            sortable: false,
            valueGetter: (params: { row: MicrojobberWrapper }) => {
                if (params.row.lastName !== null) {
                    return `${params.row.firstName} ${params.row.lastName}`
                }

                return params.row.firstName
            },
        },
        {
            ...defaultColumnDefinition,
            field: "city",
            headerName: t({
                id: "mtc-location",
                message: "Località"
            }),
            flex: 3,
            sortable: false,
        },
        {
            ...defaultColumnDefinition,
            field: "categories",
            headerName: t({
                id: "mtc-activity",
                message: "Attività",
            }),
            flex: 3,
            sortable: false,
            valueGetter: (params: { row: MicrojobberWrapper }) => {
                return params.row.categories.join(", ")
            },
        },
        // {
        //     ...defaultColumnDefinition,
        //     field: "button",
        //     flex: 2,
        //     sortable: false,
        //     renderCell: (params: { row: MicrojobberWrapper }) => (
        //         <Link key={`microjob-${params.row.id}`} to={`/microjob/${params.row.id}`}>
        //             <Button
        //                 variant="contained"
        //                 disableElevation
        //                 size="small"
        //                 sx={{
        //                     textTransform: 'none',
        //                     backgroundColor: 'secondary.main',
        //                     color: 'white',
        //                 }}>
        //                 <Typography>
        //                     <Trans id="microjob-table.view-details">
        //                         Vedi dettagli
        //                     </Trans>
        //                 </Typography>
        //             </Button>
        //         </Link>
        //     ),
        // },
    ]
}

export default getMicrojobTableColumns
